import { END_POINTS } from '@/api/end-points'
import fetch from '@/api/fetch-with-authorization'

export const signInLoader = queryClient => async () => {
  return await queryClient.ensureQueryData({
    queryKey: ['me'],
    queryFn: () => fetch({ path: END_POINTS.ME }),
  })
}
